/* Auren Naturals Cart-Drawer Rescue — patcht Shrine-Pro's CartDrawer Custom-Element
   so dass setHeaderCartIconAccessibility + trapFocus nicht mehr crashen.
   Läuft IMMER vor main.js (synchron, im <head>). */
(function () {
  'use strict';

  // 1) Globaler Error-Handler für die spezifischen CartDrawer-Crashes — verhindert Console-Spam
  //    UND verhindert dass Shopify's main.js in den /cart/clear Recovery-Pfad fällt
  window.addEventListener('error', function (ev) {
    var msg = ev.message || '';
    var src = (ev.filename || '') + '';
    if (src.indexOf('main.js') > -1 &&
        (msg.indexOf('setHeaderCartIconAccessibility') > -1 ||
         msg.indexOf('getFocusableElements') > -1 ||
         msg.indexOf('trapFocus') > -1 ||
         msg.indexOf('Cannot read properties of null') > -1)) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      console.warn('[Auren NaturalsPatch] suppressed main.js CartDrawer error:', msg);
      return true;
    }
  }, true);

  // 2) Polyfill: ensure required header DOM Elemente existieren BEVOR CartDrawer initialisiert
  function ensureHeaderShim() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return false;
    // CartDrawer erwartet ein Child mit data-cart-count Dataset
    if (!bubble.querySelector('[data-cart-count],[data-cart-quantity]')) {
      var span = document.createElement('span');
      span.className = 'cart-count-bubble';
      span.setAttribute('data-cart-count', '0');
      span.setAttribute('data-cart-quantity', '0');
      span.setAttribute('aria-hidden', 'true');
      span.style.display = 'none';
      bubble.appendChild(span);
    }
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureHeaderShim);
  } else {
    ensureHeaderShim();
  }

  // 3) Patch das CartDrawer Custom-Element sobald registriert — überschreibe broken Methoden
  function patchCartDrawer() {
    if (!window.customElements) return false;
    var ctor = customElements.get('cart-drawer');
    if (!ctor || !ctor.prototype) return false;
    if (ctor.prototype.__amarielPatched) return true;

    // setHeaderCartIconAccessibility — wrap in try/catch
    var origSet = ctor.prototype.setHeaderCartIconAccessibility;
    if (typeof origSet === 'function') {
      ctor.prototype.setHeaderCartIconAccessibility = function () {
        try { return origSet.apply(this, arguments); }
        catch (e) { console.warn('[Auren NaturalsPatch] setHeaderCartIconAccessibility skipped:', e.message); }
      };
    }

    // open() — null-safe wrapper
    var origOpen = ctor.prototype.open;
    if (typeof origOpen === 'function') {
      ctor.prototype.open = function (trigger) {
        try { return origOpen.call(this, trigger || document.body); }
        catch (e) {
          console.warn('[Auren NaturalsPatch] open() crashed, applying manual fallback:', e.message);
          this.classList.add('active', 'is-open', 'open', 'animate');
          this.removeAttribute('hidden');
          document.body.classList.add('overflow-hidden');
        }
      };
    }

    // close() — null-safe + räumt ALLE manuellen Fallback-Klassen + Overlay weg
    var origClose = ctor.prototype.close;
    if (typeof origClose === 'function') {
      ctor.prototype.close = function () {
        var self = this;
        function cleanup() {
          self.classList.remove('active', 'is-open', 'open', 'animate');
          self.style.visibility = '';
          document.body.classList.remove('overflow-hidden');
          var ov = document.getElementById('CartDrawer-Overlay');
          if (ov) ov.classList.remove('active');
        }
        try { var r = origClose.apply(this, arguments); cleanup(); return r; }
        catch (e) { cleanup(); }
      };
    }

    ctor.prototype.__amarielPatched = true;
    console.log('[Auren NaturalsPatch] CartDrawer prototype patched');
    return true;
  }

  // Polling weil customElements.define erst nach main.js läuft
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    if (patchCartDrawer() || tries > 50) clearInterval(iv);
  }, 100);

  // 4) Globale Patch für trapFocus (Helper-Function in main.js)
  //    Wir warten bis main.js geladen ist, dann wrappen wir die globale Funktion falls sie existiert
  var trapTries = 0;
  var trapIv = setInterval(function () {
    trapTries++;
    if (typeof window.trapFocus === 'function' && !window.trapFocus.__amarielPatched) {
      var orig = window.trapFocus;
      window.trapFocus = function (container, elementToFocus) {
        if (!container) { console.warn('[Auren NaturalsPatch] trapFocus called with null container — skip'); return; }
        try { return orig.apply(this, arguments); }
        catch (e) { console.warn('[Auren NaturalsPatch] trapFocus crashed:', e.message); }
      };
      window.trapFocus.__amarielPatched = true;
      console.log('[Auren NaturalsPatch] global trapFocus patched');
    }
    if (trapTries > 50) clearInterval(trapIv);
  }, 100);

  // 5) ALLE Cart-Trigger (Standard-Header + PDP-Custom-Header + Cart-Links) → Drawer
  function openDrawerFromEvent(e) {
    try {
      if (e && e.cancelable) e.preventDefault();
      if (e) e.stopPropagation();
    } catch(_) {}
    var d = document.querySelector('cart-drawer');
    if (!d) return true; // kein Drawer da → Navigation zulassen
    if (typeof d.open === 'function') {
      try { d.open(); } catch(_) {}
    }
    d.classList.add('active', 'is-open', 'open', 'animate');
    d.removeAttribute('hidden');
    d.style.visibility = 'visible';
    document.body.classList.add('overflow-hidden');
    var ov = document.getElementById('CartDrawer-Overlay');
    if (ov) ov.classList.add('active');
    return false;
  }

  // Globaler Delegate-Handler — fängt JEDEN Click auf /cart-Links ab,
  // egal in welcher Custom-Header-Section sie sitzen
  function globalCartClickHandler(e) {
    var t = e.target;
    if (!t) return;
    // Bis zum nächsten <a> klettern
    var a = t.closest && t.closest('a');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href === '/cart' || href === '/cart/' || href.indexOf('/cart?') === 0) {
      // Aber: NICHT bei Checkout-Buttons / Forms innerhalb des Drawers selbst
      if (a.closest('cart-drawer') || a.closest('#CartDrawer')) return;
      openDrawerFromEvent(e);
    }
  }

  ['click', 'touchend'].forEach(function (evName) {
    document.addEventListener(evName, globalCartClickHandler, { capture: true, passive: false });
  });

  // 6) Schließen: X-Button, Overlay-Klick, Escape — alles räumt sauber auf
  function manualClose() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    if (typeof d.close === 'function') { try { d.close(); } catch(_) {} }
    d.classList.remove('active', 'is-open', 'open', 'animate');
    d.style.visibility = '';
    document.body.classList.remove('overflow-hidden');
    var ov = document.getElementById('CartDrawer-Overlay');
    if (ov) ov.classList.remove('active');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;
    // Overlay-Klick = schließen
    if (t.id === 'CartDrawer-Overlay' || (t.classList && t.classList.contains('cart-drawer__overlay'))) {
      e.preventDefault();
      manualClose();
      return;
    }
    // Close-Button im Drawer
    var closeBtn = t.closest && t.closest('.drawer__close, [aria-label="Close"], [data-cart-close]');
    if (closeBtn && closeBtn.closest('cart-drawer')) {
      // Lass den inline-Handler laufen, danach extra-cleanup
      setTimeout(manualClose, 0);
    }
  }, true);

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' || e.keyCode === 27) {
      var d = document.querySelector('cart-drawer.active, cart-drawer.is-open');
      if (d) manualClose();
    }
  });

  console.log('[Auren NaturalsPatch] global /cart link interceptor + close-cleanup active');

  console.log('[Auren NaturalsPatch] Cart-Drawer rescue loaded');
})();
